import { createSelector } from "@reduxjs/toolkit";

export const singleDocumentsListState = (state) => state.singleDocuments;

export const singleDocumentSelectors = createSelector(singleDocumentsListState, (state) => state);
